/* 期間限定セール倒數:頂部翻牌橫幅(只在商品頁)+導航抽屜/桌機下拉檔期卡文字計時。
   排程 epoch 由 #scd-bar 或 #scd-nav-sale/#scd-mega-sale 的 data-sale-end/-start 提供
   (橫幅只掛商品頁,導航卡全站有——三者任一存在即可驅動)。
   2026-08-05 起加開始閘門 data-sale-start:開始前橫幅與導航檔期卡保持隱藏,
   到點自動顯示;網址帶 ?scd_demo=1 可在開始前強制顯示(內部預覽用)。
   歸零→淡出移除橫幅與導航檔期卡。商品卡白牌計時已依 2026-07-28 Yui 回饋移除。
   reduced-motion:不翻牌直接換字。 */
(function () {
  var bar = document.getElementById('scd-bar');
  var navSale = document.getElementById('scd-nav-sale');
  var megaSale = document.getElementById('scd-mega-sale');
  var src = bar || navSale || megaSale;
  if (!src) return;
  var end = parseInt(src.getAttribute('data-sale-end'), 10) * 1000;
  if (!end) return;
  var start = parseInt(src.getAttribute('data-sale-start') || '0', 10) * 1000;
  var demo = /[?&]scd_demo=1/.test(location.search);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timer;

  function started() { return demo || !start || Date.now() >= start; }

  /* 帶高寫入 --scd-bar-h(桌機商品頁 sticky 詳情欄讓位用,sale-countdown.css 消費);
     只在顯示瞬間與 resize 時量,不在每秒 tick 讀 offsetHeight 免強制重排 */
  var lastBarH = 0;
  function syncBarH() {
    if (!bar || bar.hidden || !bar.isConnected) return;
    var h = bar.offsetHeight;
    if (h && h !== lastBarH) {
      lastBarH = h;
      document.body.style.setProperty('--scd-bar-h', h + 'px');
    }
  }
  window.addEventListener('resize', syncBarH);
  /* 顯示瞬間量到退化布局(字體未就緒/隱藏視窗)時的自癒:load 後與 1.5s 再校一次 */
  window.addEventListener('load', syncBarH);
  setTimeout(syncBarH, 1500);
  function setNavRows(show) {
    [navSale, megaSale].forEach(function (el) {
      if (el) el.style.display = show ? '' : 'none';
    });
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function setUnit(fc, val) {
    var top = fc.querySelector('.scd-ht:not(.scd-flap) .scd-dv');
    var bot = fc.querySelector('.scd-hb .scd-dv');
    if (bot.textContent === val) return;
    if (reduce) {
      top.textContent = val;
      bot.textContent = val;
      return;
    }
    var flap = fc.querySelector('.scd-flap');
    flap.querySelector('.scd-dv').textContent = bot.textContent === '--' ? val : bot.textContent;
    top.textContent = val;
    flap.classList.remove('scd-anim');
    void flap.offsetWidth;
    flap.classList.add('scd-anim');
    setTimeout(function () { bot.textContent = val; }, 160);
  }

  function over() {
    clearInterval(timer);
    document.body.style.removeProperty('--scd-bar-h');
    /* 特效7:歸零淡出 0.45s 再移除;reduced-motion 直接移除
       (含導航抽屜檔期卡+桌機下拉面板倒數行) */
    var targets = [bar, navSale, megaSale];
    targets.forEach(function (el) {
      if (!el) return;
      if (reduce) {
        el.remove();
        return;
      }
      el.classList.add('scd-out');
      setTimeout(function () { el.remove(); }, 500);
    });
  }

  function tick() {
    if (!started()) {
      if (bar) bar.hidden = true;
      setNavRows(false);
      return;
    }
    setNavRows(true);
    var t = Math.floor((end - Date.now()) / 1000);
    if (t <= 0) {
      over();
      return;
    }
    var d = Math.floor(t / 86400);
    var h = Math.floor(t % 86400 / 3600);
    var m = Math.floor(t % 3600 / 60);
    var s = t % 60;
    var v = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
    if (bar) {
      Array.prototype.forEach.call(bar.querySelectorAll('.scd-fc'), function (fc) {
        setUnit(fc, v[fc.getAttribute('data-u')]);
      });
      var wasHidden = bar.hidden;
      bar.hidden = false;
      if (wasHidden) syncBarH();
    }
    var full = d + '日' + pad(h) + ':' + pad(m) + ':' + pad(s);
    var brief = d + '日' + pad(h) + ':' + pad(m);
    Array.prototype.forEach.call(document.querySelectorAll('.scd-long'), function (el) { el.textContent = full; });
    Array.prototype.forEach.call(document.querySelectorAll('.scd-short'), function (el) { el.textContent = brief; });
  }

  function init() {
    tick();
    timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
